// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st0{fill:#092d4a}.st1{fill:#2e568b}.st2{fill:#6fa3cc}.st3{fill:#28684a}.st4{fill:#dbcb4a}.st5{fill:#f19e24}.st6{fill:#ab2327}", ""]);
// Exports
module.exports = exports;
